// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"711be4a6","488":"b68881ba"}[chunkId] + ".chunk.js";
};